import React, { memo, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { getData } from '../../../../../assets/scripts/GeneralFunctions'
import { cleanList } from '../../../../../functions/stateList'
import SubmitButton from '../../../../buttons/SubmitButton'
import CarModalInput from '../../../../inputs/CarModalInput'
import TextAreaInput from '../../../../inputs/TextAreaInput'
import Skeleton from '../../../../skeleton/Skeleton'
import ServiceItemCheckbox from './ServiceItemCheckbox'
import ServicesStaticItem from './ServicesStaticItem'
import TireServiceData from './TireServiceData'

function ServiceItemContent({ isLoading, activeFilter, types, activeId, productWithType }) {
  const [isSubmit, setIsSubmit] = useState(false)
  const [services, setServices] = useState([])
  const [inputs, setInputs] = useState({
    current_km: '',
    description: '',
    type: 'km',
    have_issue: false,
    issue_desc: '',
  })
  const [errors, setErrors] = useState({
    current_km: '',
    description: '',
  })
  const location = useLocation()
  const navigate = useNavigate()

  const inputHandler = (e) => {
    setInputs({
      ...inputs,
      [e.target.name]: e.target.value,
    })
    setErrors({
      ...errors,
      [e.target.name]: '',
    })
  }
  const formHandler = async (e) => {
    e.preventDefault()
    const queryParams = {
      current_km: inputs.current_km,
      description: inputs.description,
      have_issue: inputs.have_issue,
      issue_desc: inputs.issue_desc,
      type: inputs.type,
      services,
    }
    setIsSubmit(true)
    const apiResult = await getData(
      `admin/visits/create/${location?.state?.carId}`,
      'post',
      queryParams,
      true,
      true
    )
    if (apiResult?.status === 200) {
      navigate(-1)
      toast.success('سرویس مورد نظر با موفقیت ثبت شد')
      setIsSubmit(false)
    } else {
      setIsSubmit(false)
      setErrors(apiResult?.error)
      for (const property in apiResult?.error) {
        toast.error(`${apiResult?.error[property]}`)
      }
    }
  }

  return (
    <form onSubmit={formHandler}>
      {isLoading ? (
        <Skeleton loadingData={true} />
      ) : (
        <div className="bg-sky-50 dark:bg-slate-700 dark:border-gray-700 border border-light-gray rounded-lg my-6 py-6 md:py-8 px-6 md:px-16">
          <div className={'grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4'}>
            {(activeId === 1 || activeId === 2) &&
              types &&
              types.map(
                (type, index) =>
                  productWithType[type]?.length > 0 && (
                    <div key={index}>
                      <ServiceItemCheckbox
                        activeFilter={activeFilter}
                        activeId={activeId}
                        label={type}
                        // name={index}
                        list={productWithType[type]}
                        services={services}
                        setServices={setServices}
                      />
                    </div>
                  )
              )}

            {activeId === 3 && (
              <TireServiceData
                activeFilter={activeFilter}
                services={services}
                setServices={setServices}
              />
            )}

            {activeId === 4 && (
              <ServicesStaticItem
                activeFilter={activeFilter}
                list={cleanList}
                services={services}
                setServices={setServices}
              />
            )}
          </div>
        </div>
      )}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        <div className={'flex flex-col mb-12'}>
          <h3 className={'text-blue text-lg font-medium mb-4 dark:text-amber-100'}>نوع پیمایش</h3>
          <div className="flex items-center gap-4">
            <label
              className={
                'text-normal font-md flex item-center mb-4 cursor-pointer dark:text-gray-200'
              }
            >
              <input
                onChange={inputHandler}
                value={'km'}
                checked={inputs?.type === 'km'}
                className={'ml-2 w-5 h-5'}
                type="radio"
                name={'type'}
              />
              کیلومتر
            </label>
            <label
              className={
                'text-normal font-md flex item-center mb-4 cursor-pointer dark:text-gray-200'
              }
            >
              <input
                onChange={inputHandler}
                value={'mile'}
                checked={inputs?.type === 'mile'}
                className={'ml-2 w-5 h-5'}
                type="radio"
                name={'type'}
              />
              مایل
            </label>
          </div>
        </div>

        <CarModalInput
          maxLength={9}
          type={'number'}
          name={'current_km'}
          value={inputs?.current_km}
          error={errors}
          title={'کارکرد فعلی'}
          inputHandler={inputHandler}
        />
      </div>

      <TextAreaInput
        name={'description'}
        value={inputs?.description}
        error={errors}
        title={'توضیحات'}
        inputHandler={inputHandler}
      />

      <div className="flex flex-col gap-2">
        <label
          htmlFor="have_issue"
          className="flex items-center gap-2 text-gray-800 dark:text-white"
        >
          <input
            onChange={() => {
              setInputs({
                ...inputs,
                have_issue: !inputs?.have_issue,
              })
            }}
            checked={inputs?.have_issue}
            className={'w-4 h-4'}
            type="checkbox"
            name={'have_issue'}
            id={'have_issue'}
          />
          خودرو مشکل فنی دارد
        </label>

        {inputs?.have_issue && (
          <TextAreaInput
            name={'issue_desc'}
            value={inputs?.issue_desc}
            error={errors}
            title={''}
            inputHandler={inputHandler}
          />
        )}
      </div>

      <div className="flex justify-center mt-12">
        <SubmitButton isSubmit={isSubmit} wFit={true} />
      </div>
    </form>
  )
}

export default memo(ServiceItemContent)
